var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect2, _rect3, _rect4, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDetails(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 925.49161,
    height: 570,
    viewBox: "0 0 925.49161 570",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 738.49161,
    y: 540,
    width: 34,
    height: 30,
    fill: "#f0f0f0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1062.7458,417A251.96689,251.96689,0,0,1,931.656,638.16c-2.25,1.23-4.53027,2.43006-6.82031,3.59a246.249,246.249,0,0,1-26.16992,11.48q-5.34009,2.01-10.79,3.74c-.34961.12006-.71.24-1.06006.34A251.50944,251.50944,0,0,1,672.966,628.03q-6.28491-4.11007-12.31006-8.58c-2.27-1.69-4.51025-3.41-6.72021-5.18q-9.375-7.44-18-15.77A251.21328,251.21328,0,0,1,558.7458,417c0-139.18,112.81983-252,252-252S1062.7458,277.82,1062.7458,417Z",
    transform: "translate(-137.2542 -165)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M870.926,534.6l-5.68018,21.48,21.56983,101.23a253.04514,253.04514,0,0,1-176.3999-9.07l16.83984-70.61.56006-38.3,1.83008-126.29.46-.24a.35886.35886,0,0,1,.09033-.04l42.8999-22.03,74.02-1.85,55.23,26.9-.41992,1.57Z",
    transform: "translate(-137.2542 -165)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M901.18984,719.14383a18.07723,18.07723,0,0,1,4.82608-27.29588l-12.01468-63.10678,30.81392,12.84144,6.68524,57.95853a18.17518,18.17518,0,0,1-30.31056,19.60269Z",
    transform: "translate(-137.2542 -165)",
    fill: "#9e616a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M891.21227,417.744l7.90639-2.573s25.08079,16.09632,22.69441,55.01212c0,0,.94,20.13752.04242,33.53963C920.826,519.09494,934.62472,671.851,934.62472,671.851H889.93241L870.77856,533.51764Z",
    transform: "translate(-137.2542 -165)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M865.28915,319.82981a51.311,51.311,0,1,1-51.31106-51.311h.00006a51.18333,51.18333,0,0,1,51.311,51.05536Q865.28945,319.702,865.28915,319.82981Z",
    transform: "translate(-137.2542 -165)",
    fill: "#9e616a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M762.83759,250.90981c6.01081-12.92526,17.64293-10.36982,27.816-5.98853,12.88266-2.85756,25.13491-11.41271,39.01522-6.35323,13.67272,19.88617,59.57811,14.03536,49.81182,46.41017-.01277,7.7577,14.59759,3.24221,12.0469,15.94754,7.73966,24.45127-27.93663,70.75832-48.4176,61.00682,5.06523-9.28322,16.63616-30.36852-.91372-32.45988-37.75247,35.12732-3.8951-66.89035-51.3302-37.222C775.16,306.62427,753.658,265.287,762.83759,250.90981Z",
    transform: "translate(-137.2542 -165)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M841.35762,662.50461l-81.90643-16.22212L780.453,540.24309q43.47156,16.44225,81.90608,16.22209C839.96651,589.3063,829.79366,624.56934,841.35762,662.50461Z",
    transform: "translate(-137.2542 -165)",
    fill: "#e4e4e4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M829.448,668.73326,747.5417,652.51117c-6.72363-48.03943-.61181-84.20816,21.002-106.0394q43.47142,16.44228,81.90621,16.22212A292.10059,292.10059,0,0,0,829.448,668.73326Z",
    transform: "translate(-137.2542 -165)",
    fill: "#273679"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M775.17993,639.19526a18.07722,18.07722,0,0,0-23.27742-15.05052l-38.03876-51.76746-11.57544,31.31149,37.8969,44.35888a18.17518,18.17518,0,0,0,34.99472-8.85239Z",
    transform: "translate(-137.2542 -165)",
    fill: "#9e616a"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M741.07355,415.771l-6.89031-4.6535S693.1833,414.935,684.7458,453c0,0-6.167,22.87-9,36-1.45708,6.75321-20.88531,72.00017-20.88531,72.00017L720.7458,633l18-27-18-45Z",
    transform: "translate(-137.2542 -165)",
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 126.51913,
    width: 34,
    height: 30,
    fill: "#273679"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 246.51913,
    width: 34,
    height: 30,
    fill: "#273679"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 451.51913,
    width: 34,
    height: 30,
    fill: "#273679"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M263.50112,222.64887a3.80011,3.80011,0,0,0,0,7.60022H540.9537a3.80012,3.80012,0,0,0,0-7.60022Z",
    transform: "translate(-137.2542 -165)",
    fill: "#e4e4e4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M263.50112,245.44951a3.80012,3.80012,0,1,0-.016,7.60022H438.89347a3.80011,3.80011,0,1,0,0-7.60022Z",
    transform: "translate(-137.2542 -165)",
    fill: "#e4e4e4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M227.50112,495.64887a3.80011,3.80011,0,0,0,0,7.60022H504.9537a3.80012,3.80012,0,0,0,0-7.60022Z",
    transform: "translate(-137.2542 -165)",
    fill: "#e4e4e4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M227.50112,518.44951a3.80012,3.80012,0,1,0-.016,7.60022H402.89347a3.80011,3.80011,0,1,0,0-7.60022Z",
    transform: "translate(-137.2542 -165)",
    fill: "#e4e4e4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M385.50112,690.64887a3.80011,3.80011,0,0,0,0,7.60022H662.9537a3.80012,3.80012,0,0,0,0-7.60022Z",
    transform: "translate(-137.2542 -165)",
    fill: "#e4e4e4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M385.50112,713.44951a3.80012,3.80012,0,1,0-.016,7.60022H560.89347a3.80011,3.80011,0,1,0,0-7.60022Z",
    transform: "translate(-137.2542 -165)",
    fill: "#e4e4e4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M153.2423,306.65471a62.55523,62.55523,0,0,0,39.66875-28.0084,59.9451,59.9451,0,0,0,6.01322-12.82909,1.50128,1.50128,0,0,0-2.84049-.96755,59.52931,59.52931,0,0,1-30.72781,34.5628,56.35748,56.35748,0,0,1-12.67462,4.29515c-1.88955.39853-1.33259,3.34646.56095,2.94709Z",
    transform: "translate(-137.2542 -165)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M182.47186,271.56226q8.11161-4.56825,16.22337-9.13658c.25053-.14031.95192-.67159,1.21384-.60809-.21-.05092-.01939.10465-.01317.29463.00838.25572.04065.5154.05023.77288.05872,1.57928.08746,3.16027.13119,4.74l.25144,9.08508c.05293,1.91223,3.047,2.13966,2.99348.20491L203.02707,266.25c-.06765-2.44417.5437-7.86545-3.41639-7.39683-1.429.1691-2.75029,1.17026-3.96916,1.85669l-4.93755,2.7807-9.52241,5.36278c-1.6769.94438-.39381,3.65733,1.2903,2.70888Z",
    transform: "translate(-137.2542 -165)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M227.56192,426.4134a62.54742,62.54742,0,0,0-38.48965,29.574,59.85394,59.85394,0,0,0-5.48876,13.05246,1.50128,1.50128,0,0,0,2.89284.79752,59.55355,59.55355,0,0,1,29.383-35.75361,56.32036,56.32036,0,0,1,12.50006-4.77757c1.87077-.47222,1.07808-3.36628-.79752-2.89284Z",
    transform: "translate(-137.2542 -165)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M199.745,462.65263l-15.67691,9.66509c-.2687.16566-.53282.34647-.81245.49369-.27757.14614-.563.14166-.38358.31781-.242-.23761-.18027-1.11882-.19839-1.3878l-.30535-4.534-.6107-9.068c-.129-1.91607-3.13-1.93042-3,0l.71691,10.64506c.16324,2.42387-.28831,7.44036,3.42248,7.23758,1.65223-.09029,3.22631-1.44749,4.58025-2.28222l4.47912-2.76145,9.30277-5.73533c1.6405-1.0114.13547-3.60744-1.51415-2.59041Z",
    transform: "translate(-137.2542 -165)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M279.149,630.30624a59.547,59.547,0,0,1,36.69675,28.19536,56.29657,56.29657,0,0,1,5.18634,12.33582,1.50128,1.50128,0,0,0,2.89283-.79752,62.54113,62.54113,0,0,0-30.76171-37.5465,59.83177,59.83177,0,0,0-13.21669-5.08c-1.87249-.47265-2.67129,2.41986-.79752,2.89284Z",
    transform: "translate(-137.2542 -165)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M306.2492,666.243l9.30278,5.73533,4.47911,2.76145c1.35742.83688,2.92553,2.1918,4.58025,2.28222,3.70982.20273,3.25919-4.81291,3.42248-7.23758l.71691-10.64506c.1298-1.92722-2.87074-1.91923-3,0l-.6107,9.068-.29207,4.33688c-.02236.3319.06453,1.30933-.21166,1.58493.1972-.19678-.00835-.10288-.2285-.23656-.32017-.19442-.64809-.378-.96754-.57494l-15.6769-9.66509c-1.648-1.016-3.15644,1.57791-1.51416,2.59041Z",
    transform: "translate(-137.2542 -165)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 71.51913,
    r: 14,
    fill: "#273679"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 345.8493,
    r: 14,
    fill: "#273679"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 540.51913,
    r: 14,
    fill: "#273679"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDetails);
export default __webpack_public_path__ + "static/media/no-details.3e1b67b976ba188a6cd9ae1c795764c2.svg";
export { ForwardRef as ReactComponent };